import React, { Fragment, PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  LabelList,
  ReferenceLine,
  Legend,
  Tooltip
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTick,
  CustomizedYAxisTick,
  COLORS,
  CustomTooltip
} from "./Common";
import { number_format } from "Utils";
import { Modal } from "antd";
import { CustomizedLabel as SBLabel } from "./StandardBarChart";

export class CustomizedLabel extends PureComponent {
  render() {
    const { x, y, width, value, color } = this.props;
    const offset = 8;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y ? (value >= 0 ? y - offset : y + offset) : 0}
          fill={color}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={10.5}
        >
          {value !== "N/A" ? number_format(value, 2, ",", " ") : ""}
        </text>
      </g>
    );
  }
}

export class ColorfullBarChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      chartData: []
    };

    this.handleBarClick = this.handleBarClick.bind(this);
  }

  handleBarClick = data => {
    const chartData = Object.values(data.children)
      .filter(child => child.label !== "")
      .map(child => ({
        name: child.label,
        value: child.value
      }));

    console.log("==", chartData);

    this.setState({
      showModal: true,
      chartData
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
      chartData: []
    });
  };

  renderInnerBarChart() {
    const { chartData } = this.state;

    return (
      <Modal
        visible={this.state.showModal}
        onOk={this.handleClose}
        onCancel={this.handleClose}
        width={1200}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
        footer={null}
      >
        <ResponsiveContainer width="100%" height={550}>
          <BarChart data={chartData}>
            <Legend
              layout="horizontal"
              verticalAlign="top"
              align="center"
              height={100}
              payload={
                chartData &&
                chartData.map((entry, index) => ({
                  value: entry.name,
                  type: "square",
                  color: COLORS[index % COLORS.length]
                }))
              }
            />
            <Tooltip
              cursor={{ fill: "#f3faff", opacity: 0.6 }}
              content={<CustomTooltip />}
            />
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis dataKey="name" axisLine={false} tick={false} />
            <YAxis
              tick={<CustomizedYAxisTick currency="€" />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <Bar
              dataKey="value"
              fill={COLORS[0]}
              animationEasing={"ease-in-out"}
              animationDuration={800}
              barSize={65}
              minPointSize={2}
            >
              {chartData &&
                chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              <LabelList dataKey="value" position="top" content={<SBLabel />} />
            </Bar>
            <ReferenceLine y={0} stroke="#00000080" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </Modal>
    );
  }

  render() {
    const {
      chartData,
      dataKeyY,
      dataKeyX,
      currency,
      // legendLabels,
      containerWidth,
      containerHeight
    } = this.props;

    return (
      <Fragment>
        <ResponsiveContainer
          width={containerWidth ? containerWidth : "100%"}
          height={containerHeight ? containerHeight : 340}
          className={styles.charts_font}
        >
          <BarChart
            data={chartData}
            margin={{ top: 30, right: 30, left: 8, bottom: -10 }}
          >
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis
              name={dataKeyX}
              dataKey={dataKeyX}
              height={50}
              interval={0}
              padding={{ left: 20, right: 20 }}
              type="category"
              tick={<CustomizedXAxisTick />}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={<CustomizedYAxisTick currency={currency} />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <ReferenceLine y={0} stroke="#6d7f9271" />

            <Bar
              dataKey={dataKeyY}
              barSize={70}
              radius={[5, 5, 5, 5]}
              // label={{ position: "top" }}
              animationEasing={"ease-in-out"}
              animationDuration={2500}
              cursor="pointer"
            >
              {chartData.map((item, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={item["color"]}
                  onClick={() => this.handleBarClick(item)}
                />
              ))}
              <LabelList
                dataKey={dataKeyY}
                content={<CustomizedLabel chartData={chartData} />}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        {this.renderInnerBarChart()}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/ColorfullBarChart.js